<template>
    <div>
        <div class="modal is-active" v-show="showDeleteModal">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Delete Leave</p>
                    <button class="delete" @click="cancel" aria-label="close"></button>
                </header>
                <section class="modal-card-body">
                    <!-- Content ... -->
                    Are you sure do you want to delete this 13th month pay permanently?
                </section>
                <footer class="modal-card-foot" style="justify-content:flex-end">
                    <button :class="buttonDelete" @click="deletePermanently">Yes</button>
                    <button class="button is-small" @click="cancel">No</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
    buttonDelete: appButton.isLoadingDanger(false)
  }),
  computed: {
    ...mapState('thirteenmonthpay', {
      showDeleteModal: state => state.showDeleteModal,
      thirteenMonthPay: state => state.thirteenMonthPay
    })
  },
  methods: {
    ...mapActions('thirteenmonthpay', ['openDeleteModal']),
    deletePermanently() {
      this.buttonDelete = appButton.isLoadingDanger(true)
      axios
        .delete(`api/thirteenmonthpays/${this.thirteenMonthPay.thirteenMonthPayId}`)
        .then(response => {
          appToast.success(response.data)
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.buttonDelete = appButton.isLoadingDanger(false)
          this.openDeleteModal({
            showDeleteModal: false
          })
        })
    },
    cancel() {
      this.openDeleteModal({
        showDeleteModal: false
      })
    }
  }
}
</script>
